import * as React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 27"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="98.993%" id="5w7ys2wmjb">
        <stop stopColor="#71ECDA" offset="0%" />
        <stop stopColor="#32B8C0" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="v4w7sgsdsa">
        <stop stopColor="#98F3E7" offset="0%" />
        <stop stopColor="#66D0D5" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M11.5.821c2.85 0 5.43 1.155 7.297 3.023a10.287 10.287 0 0 1 3.023 7.297c0 2.468-1.54 5.495-3.44 8.161-2.494 3.499-5.655 6.52-6.88 6.52-1.225 0-4.386-3.021-6.88-6.52-1.9-2.666-3.44-5.693-3.44-8.161 0-2.85 1.155-5.43 3.023-7.297A10.287 10.287 0 0 1 11.5.82Z"
        stroke="url(#v4w7sgsdsa)"
        fill="url(#5w7ys2wmjb)"
      />
      <path
        d="M7 12.169c3.07-1.498 6.006-.641 9 .378-.42 1.016-.825 2.047-1.292 3.05a.882.882 0 0 1-.68.379c-1.404.03-2.809.034-4.213 0a.9.9 0 0 1-.655-.296C8.404 14.5 7.692 13.297 7 12.169Zm2.053-5.336c1.399-.64 2.71-1.263 4.054-1.83a.732.732 0 0 1 .652.305 402.442 402.442 0 0 1 2.16 6.159c-1.625-.421-3.099-.796-4.558-1.19a.757.757 0 0 1-.316-.338c-.637-.998-1.282-1.996-1.992-3.106ZM7 11.033l1.448-3.355 1.755 2.69L7 11.035Z"
        fill="#F7FFFF"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
